import React, { useState } from 'react';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { getToken, clearToken } from './adminApi';
import Login from './Login';
import ServicesList from './ServicesList';
import ServiceEditor from './ServiceEditor';
import Bookings from './Bookings';

function Shell({ children, onLogout }) {
    return (
        <div className="admin">
            <header className="admin-topbar">
                <div className="admin-brand">Colizeum · Админка</div>
                <nav className="admin-nav">
                    <NavLink to="/admin/services" className={({ isActive }) => isActive ? 'active' : ''}>Сервисы</NavLink>
                    <a href="/" target="_blank" rel="noreferrer">Витрина ↗</a>
                    <button className="admin-logout" onClick={onLogout}>Выйти</button>
                </nav>
            </header>
            <main className="admin-main">{children}</main>
        </div>
    );
}

export default function AdminApp() {
    const [authed, setAuthed] = useState(!!getToken());
    const navigate = useNavigate();

    const handleLogout = () => {
        clearToken();
        setAuthed(false);
        navigate('/admin');
    };

    if (!authed) {
        return <Login onSuccess={() => { setAuthed(true); navigate('/admin/services'); }} />;
    }

    return (
        <Shell onLogout={handleLogout}>
            <Routes>
                <Route index element={<Navigate to="/admin/services" replace />} />
                <Route path="services" element={<ServicesList />} />
                <Route path="services/new" element={<ServiceEditor />} />
                <Route path="services/:id" element={<ServiceEditor />} />
                <Route path="services/:id/bookings" element={<Bookings />} />
                <Route path="*" element={<Navigate to="/admin/services" replace />} />
            </Routes>
        </Shell>
    );
}
